import Icon from '@/shared/components/Icon/Icon';
import { IonLabel, IonRouterLink } from '@ionic/react';
import { Trans } from 'react-i18next';
import styles from './GenericErrorComponent.module.css';
import externalUrls from '@/shared/config/externalUrls';
import { useWindowDimensions } from '@/shared/hooks/useWindowDimension';

const GenericErrorComponent = () => {
  const { isMobileView } = useWindowDimensions();
  return (
    <>
      <div className={styles.modalContainer}>
        <Icon src={`assets/icons/warning-outline.svg`} size="xlLarge" color="primary" className={styles.icon} />

        <IonLabel className={styles.title}>
          <Trans i18nKey="error.oops" />
        </IonLabel>

        <IonLabel className={styles.errorDetails}>
          <Trans i18nKey="error.technical" />
          <span className={styles.supportLink}>
            <IonRouterLink
              href={externalUrls.pages.helpInfo.support.url}
              target="_blank"
              color="primary"
              className={isMobileView ? styles.link : ''}
            >
              <Trans i18nKey="settings.customer_support" />
            </IonRouterLink>
          </span>
        </IonLabel>
      </div>
    </>
  );
};

export default GenericErrorComponent;
